var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","top":"","height":"6"}})}
var staticRenderFns = []

export { render, staticRenderFns }